var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items && _vm.items.length
    ? _c(
        "div",
        {
          staticClass: "product-line",
          on: {
            mouseenter: function($event) {
              return _vm.productLineCarousel.autoplay.stop()
            },
            mouseleave: function($event) {
              return _vm.productLineCarousel.autoplay.start()
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "swiper",
                  rawName: "v-swiper:productLineCarousel",
                  value: _vm.swiperOptions,
                  expression: "swiperOptions",
                  arg: "productLineCarousel"
                }
              ],
              staticClass: "product-line-slider"
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper product-line-slider__row" },
                _vm._l(_vm.items, function(item) {
                  return _c(
                    "div",
                    { staticClass: "swiper-slide product-line-slider__item" },
                    [
                      item.link
                        ? _c(
                            "nuxt-link",
                            {
                              staticClass: "product-line-tile",
                              attrs: { to: item.link }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "product-line-tile__image-box" },
                                [
                                  _c("div", {
                                    staticClass: "product-line-tile__image",
                                    style: {
                                      "background-image":
                                        "url(" + item.image + ")"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "product-line-tile__title" },
                                [_vm._v(_vm._s(item.title))]
                              ),
                              item.mark
                                ? _c(
                                    "span",
                                    { staticClass: "product-line-tile__mark" },
                                    [_vm._v(_vm._s(item.mark))]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          _c(
            "ul",
            { staticClass: "product-line-list" },
            _vm._l(_vm.items, function(item) {
              return _c(
                "li",
                { staticClass: "product-line-list__item" },
                [
                  item.link
                    ? _c(
                        "nuxt-link",
                        {
                          staticClass: "product-line-tile",
                          attrs: { to: item.link }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "product-line-tile__image-box" },
                            [
                              _c("div", {
                                staticClass: "product-line-tile__image",
                                style: {
                                  "background-image": "url(" + item.image + ")"
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "product-line-tile__title" },
                            [_vm._v(_vm._s(item.title))]
                          ),
                          item.mark
                            ? _c(
                                "span",
                                { staticClass: "product-line-tile__mark" },
                                [_vm._v(_vm._s(item.mark))]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a19af78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a19af78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ProductLineCarousel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5a19af78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ProductLineCarousel.vue
// module chunks = 0